import { createContext } from 'react';

export const DestinationRowsContext = createContext([]);
